

































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {譲受金額算出依頼型, 譲受金額算出結果型} from '@/type/stock/inherit/input/item';
import {
  日付型,
  譲受削除依頼型,
  譲受修正依頼型,
  譲受修正型,
  譲受修正バリデータマップ一覧,
  譲受検索条件バリデータ一覧,
  修正前譲受型,
  譲受検索条件型,
  譲受修正検索結果型,
} from '@/type/stock/inherit/modification/item';
import api from '@/infrastructure/api/api';
import {ValidationResult} from '@/type/validation/result';
import moment from 'moment';
import {progress} from '@/script/progress';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import TransferMedicalSelector from '@/components/transfermedical/TransferMedicalSelector.vue';
import {loginModule} from '@/store/authentication/login';
import AmountField from '@/components/atom/input/AmountField.vue';
import StockUserSelector from '@/views/stock/StockUserSelector.vue';
import ToggleButtonField from '@/views/stock/StockToggleButtonField.vue';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AlertDialog,
    ConfirmDialog,
    DepartmentSelector,
    TransferMedicalSelector,
    AmountField,
    StockUserSelector,
    ToggleButtonField,
  },
})
export default class InheritModification extends Vue {

  private itemModal: boolean = false;
  private 譲受検索条件: 譲受検索条件型 = this.検索条件初期値を取得();
  private 譲受取込結果: 譲受修正型[] = [];

  private 譲受削除対象: 譲受修正型 | null = null;
  private 譲受金額算出対象: 譲受修正型 | null = null;
  private 選択中譲受先部署コード: string = loginModule.部署コードを取得する;
  private 譲受先部署コード: string = '';
  private 譲受担当薬剤師: string = '';

  // バリデーション用フィールド
  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(譲受検索条件バリデータ一覧);
  private 譲受修正バリデーション結果: ValidationResult = new ValidationResult(譲受修正バリデータマップ一覧);

  private アラートメッセージ: string | string[] | null = null;

  private 選択中の行index: number|null = null;

  public mounted() {
    if (this.利用ユーザーである()) {
      this.部署を確定する();
    }
  }

  public beforeUpdate() {
    // データ更新時にバリデート処理
    this.検索条件バリデーション結果.validate(this.譲受検索条件);
    this.譲受修正バリデーション結果.validateList(this.譲受取込結果);
  }

  @Watch('譲受取込結果', {deep: true})
  private リストが変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  private 検索条件入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private created(): void {
    moment.locale('ja');
  }

  private 部署を確定する() {
    if (this.選択中譲受先部署コード === null) {
      this.アラートメッセージ = '部署を選択してください';
      this.ダイアログを開く('アラート');
      return;
    }
    this.譲受先部署コード = this.選択中譲受先部署コード;
  }

  private マスターである(): boolean {
    return loginModule.マスターである;
  }

  private 利用ユーザーである(): boolean {
    return !loginModule.管理者である;
  }

  private バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  private 部署確定済(): boolean {
    return this.譲受先部署コード !== '';
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private クリアメッセージ(): string {
    if (viewEditingStateModule.画面を編集中である) {
      return '編集中のデータは破棄されますが、よろしいですか？';
    }
    return 'クリアしますか？';
  }

  private async クリアするハンドラ() {
    await this.クリアする()
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async クリアする(): Promise<void> {
    this.譲受取込結果 = [];
    this.譲受削除対象 = null;
    this.譲受金額算出対象 = null;
    this.選択中の行index = null;
    this.譲受検索条件 = this.検索条件初期値を取得();
    this.譲受担当薬剤師 = '';

    this.選択中譲受先部署コード = loginModule.部署コードを取得する;
    if (!this.利用ユーザーである()) {
        this.譲受先部署コード = '';
    }

    this.ダイアログを閉じる('クリアダイアログ');
  }

  private 部署未確定(): boolean {
    return !this.部署確定済();
  }

  private 検索条件初期値を取得(): 譲受検索条件型 {
    return {
      部署コード: '',
      譲受日付FROM: moment().startOf('month').toDate(),
      譲受日付TO: null,
      メーカー名: '',
      商品名カナ: '',
      譲受医療機関コード: '',
      登録者コード: loginModule.管理者である ? '' : loginModule.利用者コードを取得する,
    };
  }

  private APIアラートダイアログを開く(data: any) {
    this.アラートメッセージ = this.APIアラートメッセージを取得(data);
    this.ダイアログを開く('アラート');
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  private async 編集を破棄して譲受検索を実行するハンドラ() {
    this.ダイアログを閉じる('編集中検索確認ダイアログ');
    await progress(this.譲受検索)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 譲受検索ハンドラ() {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.ダイアログを開く('アラート');
      return;
    }

    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中検索確認ダイアログ');
      return;
    }

    await progress(this.譲受検索)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 譲受検索(): Promise<void> {
    this.譲受検索条件.部署コード = this.選択中譲受先部署コード;
    await api.譲受を検索する(this.譲受検索条件)
            .then((response: 譲受修正検索結果型) => {
              this.譲受取込結果 = response.譲受修正一覧;
              this.譲受取込結果.forEach((譲受修正) => {
                        譲受修正.修正前譲受 = this.修正前譲受を作成する(譲受修正);
                      },
              );
              if (this.譲受取込結果.length === 0) {
                this.アラートメッセージ = '検索結果が0件です。';
                this.ダイアログを開く('アラート');
              }
              if (response.アラートメッセージ) {
                this.アラートメッセージ = response.アラートメッセージ;
                this.ダイアログを開く('アラート');
              }
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
              this.譲受取込結果 = [];
            });
  }

  private 修正前譲受を作成する(譲受: 譲受修正型): 修正前譲受型 {
    return {
      譲受医療機関コード: 譲受.譲受医療機関コード,
      譲受担当薬剤師: 譲受.譲受担当薬剤師,
      有効期限: 譲受.有効期限,
      ロット番号: 譲受.ロット番号,
      譲受数: 譲受.譲受数,
      譲受単価: 譲受.譲受単価,
      バラ単位区分: 譲受.バラ単位区分,
      譲受日付: 譲受.譲受日付,
      備考: 譲受.備考,
    };
  }

  private 確定対象トグルボタンが無効である(譲受修正: 譲受修正型): boolean {
    return !this.行が修正されている(譲受修正);
  }

  private 確定対象ボタンを制御する(行番号: number): void {
    const current = this.譲受取込結果[行番号];
    if (this.行が修正されている(current)) {
      current.譲受確定対象 = '対象';
      return;
    }
    current.譲受確定対象 = '対象外';
  }

  private 行が修正されている(譲受修正: 譲受修正型): boolean {
    if (譲受修正.譲受医療機関コード !== 譲受修正.修正前譲受.譲受医療機関コード) return true;
    if (this.文字列フォーマット(譲受修正.譲受担当薬剤師) !== this.文字列フォーマット(譲受修正.修正前譲受.譲受担当薬剤師)) return true;
    if (this.日付フォーマット(譲受修正.有効期限) !== this.日付フォーマット(譲受修正.修正前譲受.有効期限)) return true;
    if (this.文字列フォーマット(譲受修正.ロット番号) !== this.文字列フォーマット(譲受修正.修正前譲受.ロット番号)) return true;
    if (譲受修正.譲受数 !== 譲受修正.修正前譲受.譲受数) return true;
    if (譲受修正.譲受単価 !== 譲受修正.修正前譲受.譲受単価) return true;
    if (譲受修正.バラ単位区分 !== 譲受修正.修正前譲受.バラ単位区分) return true;
    if (this.日付フォーマット(譲受修正.譲受日付) !== this.日付フォーマット(譲受修正.修正前譲受.譲受日付)) return true;
    if (this.文字列フォーマット(譲受修正.備考) !== this.文字列フォーマット(譲受修正.修正前譲受.備考)) return true;
    return false;
  }

  private 日付フォーマット(date: 日付型): string | null {
    if (date === null) {
      return '';
    }
    return moment(date).format('YYYY/MM/DD');
  }

  private 文字列フォーマット(value: string) {
    if (!value) {
      return '';
    }
    return value;
  }

  private エラー判定(行番号: number, 項目名: string) {
    return {'input-error': this.譲受修正バリデーション結果.hasError(項目名, 行番号)};
  }

  private 数値入力エラー判定(行番号: number, 項目名: string): boolean {
    return this.譲受修正バリデーション結果.hasError(項目名, 行番号);
  }

  private 譲受の削除を確認する(選択譲受: 譲受修正型) {
    this.譲受削除対象 = 選択譲受;
    this.ダイアログを開く('削除ダイアログ');
  }

  private async 譲受を削除するハンドラ() {
    this.ダイアログを閉じる('削除ダイアログ');
    await progress(this.譲受を削除する)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 譲受を削除する(): Promise<void> {
    if (this.譲受削除対象 === null) {
      this.アラートメッセージ = '削除対象が選択されていません';
      this.ダイアログを開く('アラート');
      return;
    }

    const 譲受削除依頼: 譲受削除依頼型 = {譲受SEQ: this.譲受削除対象.譲受SEQ, 更新バージョン: this.譲受削除対象.更新バージョン};
    await api.譲受を削除する(譲受削除依頼)
            .then((response: any) => {
              this.譲受取込結果 = this.譲受取込結果.filter((data) => data.譲受SEQ !== 譲受削除依頼.譲受SEQ);
              this.譲受削除対象 = null;
              this.譲受金額算出対象 = null;
              this.選択中の行index = null;
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
            });
  }

  private 削除ダイアログを閉じる() {
    this.譲受削除対象 = null;
    this.ダイアログを閉じる('削除ダイアログ');
  }

  private async 譲受金額算出ハンドラ(譲受修正: 譲受修正型): Promise<void> {
    this.譲受金額算出対象 = 譲受修正;
    await progress(this.譲受金額算出);
  }

  private async 譲受金額算出(): Promise<void> {
    if (this.譲受金額算出対象 === null) {
      return;
    }
    const 譲受SEQ = this.譲受金額算出対象.譲受SEQ;
    const 譲受金額算出依頼: 譲受金額算出依頼型 = {譲受数: this.譲受金額算出対象.譲受数, 譲受単価: this.譲受金額算出対象.譲受単価};
    await api.譲受金額を算出する(譲受金額算出依頼)
            .then((response: 譲受金額算出結果型) => {
              const 譲受金額算出結果 = response;
              this.譲受取込結果.filter((譲受) => 譲受.譲受SEQ === 譲受SEQ).map(
                      (譲受: 譲受修正型) => {
                        譲受.譲受金額 = 譲受金額算出結果.譲受金額;
                      },
              );
              this.譲受金額算出対象 = null;
            }).catch((error: any) => {
              // TODO エラー内容を出力する方法が必要
              // ダイアログ出すとonBlurイベントが発生して無限ループとなるためダイアログは不可。
              // this.APIアラートダイアログを開く(error.data);
            });
  }

  private async 確定ハンドラ(): Promise<void> {
    const 確定対象一覧 = this.譲受取込結果.filter((譲受修正) => 譲受修正.譲受確定対象 === '対象');
    if (確定対象一覧.length < 1) {
      this.アラートメッセージ = '確定対象が存在しません';
      this.ダイアログを開く('アラート');
      return;
    }
    if (this.譲受修正バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.譲受修正バリデーション結果.getMessages(true);
      this.ダイアログを開く('アラート');
      return;
    }
    await progress(this.修正確定)
            .then((response: any) => {
              viewEditingStateModule.画面の編集を終了する();
            }).catch((error: any) => {
              return;
            });
  }

  private async 修正確定(): Promise<void> {
    const 確定対象一覧 = this.譲受取込結果.filter((譲受修正) => 譲受修正.譲受確定対象 === '対象');
    const 譲受修正依頼: 譲受修正依頼型 = {譲受修正一覧: 確定対象一覧, 譲受先部署: this.譲受先部署コード};
    await api.譲受を修正する(譲受修正依頼)
            .then((response: any) => {
              this.譲受削除対象 = null;
              this.譲受金額算出対象 = null;
              this.選択中の行index = null;
              this.譲受検索()
                      .then((譲受検索response: any) => {
                        viewEditingStateModule.画面の編集を終了する();
                      }).catch((譲受検索error: any) => {
                        return;
                      });
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
            });
  }

  private アラートダイアログを開く(event: Event) {
    this.アラートメッセージ = event.toString().split(',');
    this.ダイアログを開く('アラート');
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 単位名リスト(譲受: 譲受修正型) {
      return [
        {バラ単位区分: '包装単位', 単位名: 譲受.包装単位名},
        {バラ単位区分: '包装数量', 単位名: 譲受.包装数量単位名},
      ];
  }

}
